import { render, staticRenderFns } from "./resa.vue?vue&type=template&id=c7045dc0&"
import script from "./resa.vue?vue&type=script&lang=js&"
export * from "./resa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports